import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'app-input-toggle-small',
    templateUrl: './input-toggle-small.component.html',
    styleUrl: './input-toggle-small.component.scss',
    standalone: false
})
export class InputToggleSmallComponent {
  @Input() useIconToolTip;
  @Input() control;
  @Input() tooltip;
  @Output() changeUpdate = new EventEmitter<any>();
  constructor(private cd: ChangeDetectorRef) {}

  toggle($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    this.changeUpdate.emit($event);
  }
}
